var chunkMapping = {
	"920": [
		1920
	]
};
var idToExternalAndNameMapping = {
	"1920": [
		"default",
		"./main",
		3767
	]
};
var idToRemoteMap = {
	"1920": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3767
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}